import { types as sdkTypes } from './sdkLoader';
import {
  isReolinkSecurityCameraListing,
  shouldShowReolinkPromoPrice,
} from './promoReolinkWeekendClient';

const { Money } = sdkTypes;

/**
 * Returns a Money for display when Reolink weekend promo applies; otherwise returns listing.attributes.price.
 */
export const getListingPriceWithReolinkPromoMaybe = (listing, ctx) => {
  const price = listing?.attributes?.price;
  const publicData = listing?.attributes?.publicData;
  if (!price || !publicData) return price;

  const hasFlag =
    typeof ctx?.locationSearch === 'string' &&
    new URLSearchParams(ctx.locationSearch).get('promoReolink') === '1';

  const consumed =
    ctx?.currentUser?.attributes?.privateData?.promos?.reolinkWeekend2026Consumed === true;

  if (
    !isReolinkSecurityCameraListing(publicData) ||
    !shouldShowReolinkPromoPrice({
      currentUser: ctx?.currentUser,
      hasPromoQueryFlag: hasFlag,
      reolinkPromoConsumed: consumed,
    })
  ) {
    return price;
  }

  const amount = price.amount;
  if (!Number.isFinite(amount) || amount <= 0) return price;
  const discountedAmount = Math.max(0, Math.round(amount * 0.95));
  if (discountedAmount === amount) return price;
  return new Money(discountedAmount, price.currency);
};
